import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';
import { getSlidesData } from '@ifeng-fe/container_content/common/client/services/api';
import { InformationFlow } from '@ifeng-fe/three_terminal/es/mobile/informationFlow/index.js';
const formatPlayNum = (playNum) => {
    let formated = '';

    if (playNum < 10000 && playNum > 0) {
        formated = playNum;
    } else {
        formated = `${(playNum / 10000).toFixed(1)}万`;
    }

    return formated;
};

class Info extends React.PureComponent {
    static propTypes = {
        data: PropTypes.object,
        count: PropTypes.object,
    };

    state = {
        slideNum: 0,
    };

    async componentDidMount() {
        const {
            data: { type, base62Id, thumbnails },
        } = this.props;

        if (type === 'slide' && thumbnails && thumbnails.length === 3) {
            let slideNum = 0;

            try {
                const data = await getSlidesData(base62Id);

                slideNum = data.slideData.length;
            } catch (e) {
                console.error(e);
            }

            this.setState({
                slideNum,
            });
        }
    }

    render() {
        const { slideNum } = this.state;
        const { data, count } = this.props;

        if (Number(data.status) === 8) {
            return null;
        }

        if ((!data.thumbnail || data.thumbnail === '') && data.thumbnails && data.thumbnails.length > 0) {
            data['thumbnail'] = data.thumbnails[0].url;
        }

        // 直播状态
        let liveStatus = '';

        if (data.type === 'directSeeding') {
            data.url = data.wwwUrl;

            const currentDate = new Date();
            const currentTime = currentDate.getTime();

            const startDate = new Date(data.startTime);
            const startT = startDate.getTime();

            const endDate = new Date(data.endTime);
            const endT = endDate.getTime();

            if (currentTime < startT) {
                liveStatus = styles.b_logo;
            } else if (currentTime > endT) {
                liveStatus = styles.o_logo;
            } else {
                liveStatus = styles.l_logo;
            }
        }

        if (data.type === 'survey') {
            data.url = data.wwwUrl || data.url;
        }

        return (
            <div className={`${styles.info_box} ${data.type === 'quan' ? styles.info_box_quan : ''}`}>
                {data.type === 'slide' && data.thumbnails && data.thumbnails.length === 3 ? (
                    <div className={styles.slide_box}>
                        <p className={styles.slide_text}>
                            <a href={data.url} target="_blank" title={data.title}>
                                {data.title}
                            </a>
                        </p>
                        <div className={styles.img_box}>
                            <a href={data.url} target="_blank" title={data.title}>
                                {data.thumbnails.map((item, index) => (
                                    <img
                                        key={index}
                                        className={index === data.thumbnails.length - 1 ? '' : styles.img}
                                        src={item.url}
                                        width="203"
                                        height="135"
                                    />
                                ))}
                            </a>
                            <div className={styles.slide_logo}>
                                <span />
                                <span>{slideNum}</span>
                            </div>
                        </div>
                        <p className={styles.slide_time}>
                            <span className={styles.source}>{data.source || data.ESsourceAlias}</span>
                            {count && count.count ? (
                                <span className={styles.date}>{`${formatPlayNum(count.count)}评`}</span>
                            ) : (
                                ''
                            )}
                        </p>
                    </div>
                ) : (
                    <React.Fragment>
                        {data.type === 'quan' ? (
                            <InformationFlow
                                getVideoPlayNum={false}
                                isDisplayLoadingMore={false}
                                isFormatTime={true}
                                content={[data]}
                                isNoPadding={true}
                            />
                        ) : (
                            <React.Fragment>
                                {data.thumbnail && data.thumbnail !== '' ? (
                                    <div className={styles.pic}>
                                        <a href={data.url} target="_blank">
                                            <LazyImg src={data.thumbnail} alt={data.title} width="148" height="98" />
                                        </a>
                                        {data.type === 'video' ? <div className={styles.v_logo} /> : ''}
                                        {data.type === 'directSeeding' ? <div className={liveStatus} /> : ''}
                                    </div>
                                ) : (
                                    ''
                                )}
                                <div className={styles.text_box}>
                                    <p className={styles.text}>
                                        <a href={data.url} target="_blank" title={data.title}>
                                            {data.title}
                                        </a>
                                    </p>
                                    <p className={styles.time}>
                                        <span className={styles.source}>{data.source || data.ESsourceAlias}</span>
                                        {count && count.join_count ? (
                                            <span className={styles.date}>{`${formatPlayNum(
                                                count.join_count,
                                            )}评`}</span>
                                        ) : (
                                            ''
                                        )}
                                    </p>
                                </div>
                            </React.Fragment>
                        )}
                    </React.Fragment>
                )}
            </div>
        );
    }
}

export default errorBoundary(Info);
